<script>
import DialogBase from "../../dialog/components/dialog-base.vue";
import DialogBody from "../../dialog/components/dialog-body.vue";
import Loading from "../../common/loading.vue";
import DialogHeader from "../../dialog/components/dialog-header.vue";
import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";

export default {
    name: "campaign-save-dialog",
    components: {DialogActionbar, DialogHeader, Loading, DialogBody, DialogBase},
    data() {
        return {
            showDialog: false,
        }
    },
    computed: {
        translations() {
            return {
                close: Lang.langGet("Close"),
                title: Lang.langGet("Saving original"),
                description: Lang.langGet("You are updating the original campaign. Are you sure?"),
                saveAsOriginal: Lang.langGet("Save As Original"),
                saveAsCopy: Lang.langGet("Save As Copy"),
            }
        }
    },
    methods: {
        show() {
            this.showDialog = true;
        },
        hide() {
            this.showDialog = false;
        },
        handleClose() {
            this.hide();
        },
        saveAsOriginal() {
            EaseEventBus.fire('saveAsOriginal');
            this.handleClose();
        },
        saveAsCopy() {
            EaseEventBus.fire('saveAsCopy');
            this.handleClose();
        }
    },
    async mounted() {
        EaseEventBus.listen('showSaveCampaignDialog', () => {
            this.show();
        });
    }
}
</script>

<template>
    <dialog-base
        :max-width="600"
        @close="handleClose"
        :showDialog="showDialog"
    >
        <dialog-header
            @close="handleClose"
            :title="translations.title"
        />
        <dialog-body>
            <div class="campaign-save-dialog">
                <p class="text-center">
                    {{ translations.description }}
                </p>
            </div>
        </dialog-body>
        <dialog-actionbar
            @close="handleClose"
            @save="saveAsCopy"
            :confirm-text="translations.saveAsCopy"
        >
            <v-btn @click="saveAsOriginal">
                {{ translations.saveAsOriginal }}
            </v-btn>
        </dialog-actionbar>
    </dialog-base>
</template>

<style scoped>
.campaign-save-dialog {
    font-size: 16px;
    margin: 26px 16px 10px 18px !important;
}
</style>
